import { apiClient } from './api';

const profileAPI = {
  // Get user profile
  getProfile: () => {
    return apiClient.get('/profile');
  },

  // Update user profile
  updateProfile: (data) => {
    return apiClient.put('/profile', data);
  },

  // Upload profile picture
  uploadProfilePicture: (formData) => {
    return apiClient.post('/profile/picture', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Get profile image
  getProfileImage: (userId, size = null) => {
    const sizeParam = size ? `?w=${size}` : '';
    return apiClient.get(`/profile/image/${userId}${sizeParam}`);
  },

  // Upload institute logo (for super admin)
  uploadInstituteLogo: (formData) => {
    return apiClient.post('/institute/upload-logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default profileAPI;
